import { componentsThemeMap } from '../componentsThemeMap.js';
import { SectionComponentLayout } from '../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../providers/AnalyticsProvider.js';
import '../ui/Div/index.js';
import { ErrorBoundary } from '../ui/ErrorBoundary.js';
import { Text } from '../ui/Text.js';
import '../ui/VideoPlayer/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../ui/Div/Div.js';
import { VideoPlayer } from '../ui/VideoPlayer/VideoPlayer.js';
const DEFAULT_ALT_TEXT = 'Video highlight';
function HighlightVideo({
  mediaUrl,
  thumbnailUrl,
  thumbnailAlt = DEFAULT_ALT_TEXT,
  caption,
  hasSpacingTop,
  hasSpacingAround = false,
  style = 'default',
  anchor,
  hasLightbox
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    background = _componentsThemeMap$s.background,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary;
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HighlightVideo",
      children: /*#__PURE__*/jsx(SectionComponentLayout, {
        hasSpacingTop: hasSpacingTop,
        hasSpacingHorizontal: hasSpacingAround,
        hasNonDefaultBackgroundSpacingVertical: true,
        anchor: anchor,
        background: background,
        children: /*#__PURE__*/jsxs(Div, {
          flexDirection: "column",
          children: [/*#__PURE__*/jsx(VideoPlayer, {
            src: mediaUrl,
            thumbnailUrl: thumbnailUrl,
            thumbnailAlt: thumbnailAlt,
            hasLightbox: hasLightbox
          }), caption && /*#__PURE__*/jsx(Text, {
            variant: "caption",
            as: "p",
            color: foregroundSecondary,
            spacingTop: 3,
            children: caption
          })]
        })
      })
    })
  });
}
export { HighlightVideo };
//# sourceMappingURL=HighlightVideo.js.map
